"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningCallOut = exports.InformationalCallOut = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _close = _interopRequireDefault(require("../../icons/close"));
var _use_dismissable = _interopRequireDefault(require("../../hooks/use_dismissable"));
var _grid = require("../../layouts/grid");
var _typography = require("../../typography");
var _buttons = require("../buttons");
var _theme = _interopRequireDefault(require("./theme"));
var _error = _interopRequireDefault(require("../../icons/error"));
var _question = _interopRequireDefault(require("../../icons/question"));
var _constants = require("../../utils/constants");
var _compact_row = require("../../layouts/compact_row");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CallOutWrapper = _styledComponents["default"].div.withConfig({
  displayName: "call_out__CallOutWrapper"
})(["background:", ";border-radius:5px;padding:1rem 1.5rem;"], function (_ref) {
  var $backgroundColor = _ref.$backgroundColor;
  return $backgroundColor;
});
function buildButton(props, key) {
  if (props.buttonType === 'danger') {
    return /*#__PURE__*/React.createElement(_buttons.DangerButton, (0, _extends2["default"])({}, props, {
      key: key
    }));
  } else {
    return /*#__PURE__*/React.createElement(_buttons.SecondaryButton, (0, _extends2["default"])({}, props, {
      key: key
    }));
  }
}
function buildCallToAction(buttonProps) {
  if (!buttonProps) {
    return null;
  }
  if (Array.isArray(buttonProps)) {
    return /*#__PURE__*/React.createElement(_compact_row.CompactRow, null, buttonProps.map(function (props, index) {
      return buildButton(props, index);
    }));
  }
  return buildButton(buttonProps, 1);
}
var CallOut = function CallOut(props) {
  var _useDismissable = (0, _use_dismissable["default"])('callOut', props.dismissableKey),
    _useDismissable2 = (0, _slicedToArray2["default"])(_useDismissable, 2),
    dismissed = _useDismissable2[0],
    setAsDismissed = _useDismissable2[1];
  if (dismissed) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var mainContent = /*#__PURE__*/React.createElement(React.Fragment, null, props.headerText && /*#__PURE__*/React.createElement(_typography.Body, {
    medium: true,
    "data-provides": "call-out--header-text"
  }, props.headerText), typeof props.bodyText === 'string' ? /*#__PURE__*/React.createElement(_typography.Body, {
    "data-provides": "call-out--body-text"
  }, props.bodyText) : props.bodyText, props.linkProps && /*#__PURE__*/React.createElement(_typography.Link, props.linkProps));
  var callToAction = buildCallToAction(props.buttonProps);
  var closeIcon = /*#__PURE__*/React.createElement(DismissButton, {
    "data-provides": "call-out--dismiss",
    onClick: setAsDismissed
  }, /*#__PURE__*/React.createElement(_close["default"], {
    color: _theme["default"]["default"].closeIconColor
  }));
  return /*#__PURE__*/React.createElement(_grid.Grid, (0, _extends2["default"])({
    container: true
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(CallOutWrapper, {
    $backgroundColor: props.backgroundColor
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, props.icon), /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, mainContent), callToAction && /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, callToAction))), props.dismissableKey && /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, closeIcon)))));
};
var InformationalCallOut = exports.InformationalCallOut = function InformationalCallOut(props) {
  return /*#__PURE__*/React.createElement(CallOut, (0, _extends2["default"])({}, props, {
    backgroundColor: _theme["default"].informational.backgroundColor,
    icon: /*#__PURE__*/React.createElement(_question["default"], {
      color: _theme["default"].informational.iconColor
    })
  }));
};
InformationalCallOut.displayName = 'InformationalCallOut';
InformationalCallOut.defaultProps = {
  'data-provides': 'informational-callout'
};
var WarningCallOut = exports.WarningCallOut = function WarningCallOut(props) {
  return /*#__PURE__*/React.createElement(CallOut, (0, _extends2["default"])({}, props, {
    backgroundColor: _theme["default"].warning.backgroundColor,
    icon: /*#__PURE__*/React.createElement(_error["default"], {
      color: _theme["default"].warning.iconColor
    })
  }));
};
WarningCallOut.displayName = 'WarningCallOut';
WarningCallOut.defaultProps = {
  'data-provides': 'warning-callout'
};
var DismissButton = _styledComponents["default"].button.withConfig({
  displayName: "call_out__DismissButton"
})(["background:none;border:none;border-radius:50%;cursor:pointer;padding:0;height:1.5rem;width:1.5rem;"]);